// extracted by mini-css-extract-plugin
export var banner = "_oo-0";
export var settingRow = "_oo-2";
export var titleIcon = "_oo-1";